import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { ENGLISH } from "locales/constants";
import { namespaces, resources } from "./locales/translationsConfig";

// Configure i18next with namespaces
i18n.use(initReactI18next).init({
  debug: false,
  ns: namespaces,
  defaultNS: "ui",
  resources,
  fallbackLng: ENGLISH,
  lng: ENGLISH, //default language
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
